import { SHOW_HEADBAND, HIDE_HEADBAND } from '../actions/headband';

const initialState = {
  isVisible: false,
  message: '',
  headbandAction: null,
};

export default function headband(state = initialState, action) {
  switch (action.type) {
    case SHOW_HEADBAND: {
      if (state.timestamp && action.timestamp <= state.timestamp) {
        return { ...state };
      }
      return {
        isVisible: true,
        message: action.meta.message,
        headbandAction: action.meta.action,
      };
    }
    case HIDE_HEADBAND: {
      return { isVisible: false, message: '', timestamp: action.timestamp };
    }

    default:
      return state;
  }
}
